<template>
  <div
    class="app-simple-select"
    v-click-outside="
      () => {
        this.pickerEnabled = false
      }
    "
  >
    <div class="selector" @click="openPicker">
      <input type="text" :class="['form-control selected-value', { 'is-invalid': !isValid }]" :value="activeTitle" disabled />
      <i class="ion ion-ios-arrow-down arrow"></i>
    </div>
    <div class="picker" v-if="pickerEnabled" @keyup.esc="pickerEnabled = false">
      <div class="options" ref="options">
        <div :class="['option', { active: option.active }]" v-for="(option, i) in options" :key="i" @click="optionSelect(option)">
          {{ option.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppSimpleSelect',
  props: {
    options: {
      type: Array, // expect list of objects {value: 'foo', title: 'bar', active: true}
      required: true
    },
    notSelectedTitle: {
      type: String,
      default: 'Not selected'
    },
    isValid: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    pickerEnabled: false
  }),
  computed: {
    active() {
      return this.options.find((option) => option.active)
    },
    activeTitle() {
      if (this.active) return this.active.title
      return this.notSelectedTitle
    }
  },
  methods: {
    openPicker() {
      this.pickerEnabled = true
      this.$nextTick(() => {
        let activeOption = this.$refs.options.getElementsByClassName('active')[0]
        if (activeOption) activeOption.scrollIntoView()
      })
    },
    optionSelect(option) {
      this.$emit('change', option)
      this.pickerEnabled = false
    }
  }
}
</script>

<style scoped lang="scss">
.app-simple-select {
  position: relative;
}

.selector {
  cursor: pointer;
}

.selected-value {
  background: inherit;
}

.arrow {
  position: absolute;
  right: 5px;
  top: 33%;
  cursor: pointer;
}

.picker {
  position: absolute;
  background: #fff;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.4);
  z-index: 1;
  right: 0;
}

.options {
  max-height: 250px;
  overflow-y: scroll;
  overflow-x: hidden;

  .option {
    padding: 5px 8px;
    display: block;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      background: #ccc;
    }
  }
}
</style>
